module.exports = __webpack_public_path__ + "img/torusDashboard5.81cd2480.svg";